// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".calenDetaile{padding:.52083vw}.calenDetaile div{font-size:1.25vw;font-family:PingFang SC;font-weight:700;margin-bottom:1.04167vw}.calenDetaile span{display:inline-block;width:7.8125vw}.calenDetaile p{font-size:.83333vw;font-family:PingFang SC;font-weight:400;margin:.83333vw 0}.calenDetaile i{margin-right:.52083vw}.calenDetaile .his{margin-top:1.5625vw}", ""]);
// Exports
module.exports = exports;
